module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-passport-credit"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center flex-column align-items-center"
  }, [_c('div', {
    staticClass: "d-flex flex-column align-items-center"
  }, [_c('div', {
    staticClass: "row d-flex justify-content-center text-center"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.imgLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), (!_vm.creditCard && !_vm.imgLoading) ? _c('div', {
    staticClass: "col-8 upload-section"
  }, [_c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('input', {
    staticClass: "upload-file",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onUploadFileChange
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("booking.detail.form.upload_credit_card_title")))])]) : _vm._e(), _vm._v(" "), (_vm.creditCard && !_vm.imgLoading) ? _c('div', {
    staticClass: "col-5 passport-card-image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.creditCard.name,
      "alt": "credit card"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "remove-image"
  }, [_c('button', {
    staticClass: "btn btn-block btn-warning waves-effect waves-classic waves-effect waves-classic",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteFile(_vm.creditCard.id)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("input.replace")) + "\n            ")])])]) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "passport-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/pay.svg",
      "width": "80",
      "alt": "id card"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e174e3c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/form/show/checkin-form/UploadCreditCard.vue
// module id = 1417
// module chunks = 0